module.exports = __webpack_public_path__ + "static/tableau-de-bord-4b2eecb22fa82ac3fcaa190192a18ce6.jpg";